import { render, staticRenderFns } from "./tiptapMentionList.vue?vue&type=template&id=08413128"
import script from "./tiptapMentionList.vue?vue&type=script&lang=js"
export * from "./tiptapMentionList.vue?vue&type=script&lang=js"
import style0 from "./tiptapMentionList.vue?vue&type=style&index=0&id=08413128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports